var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFillInTheBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "34px",
    viewBox: "0 0 57 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.25,4.75 L52.25,28.5 L4.75,28.5 L4.75,4.75 L52.25,4.75 Z M57,0 L0,0 L0,33.25 L57,33.25 L57,0 Z M14.25,7.125 L7.125,7.125 L7.125,11.875 L14.25,11.875 L14.25,7.125 Z M21.375,7.125 L16.625,7.125 L16.625,11.875 L21.375,11.875 L21.375,7.125 Z M28.5,7.125 L23.75,7.125 L23.75,11.875 L28.5,11.875 L28.5,7.125 Z M35.625,7.125 L30.875,7.125 L30.875,11.875 L35.625,11.875 L35.625,7.125 Z M42.75,7.125 L38,7.125 L38,11.875 L42.75,11.875 L42.75,7.125 Z M49.875,7.125 L45.125,7.125 L45.125,11.875 L49.875,11.875 L49.875,7.125 Z M40.375,21.375 L16.625,21.375 L16.625,26.125 L40.375,26.125 L40.375,21.375 Z M49.875,14.25 L40.375,14.25 L40.375,19 L49.875,19 L49.875,14.25 Z M16.625,14.25 L7.125,14.25 L7.125,19 L16.625,19 L16.625,14.25 Z M23.75,14.25 L19,14.25 L19,19 L23.75,19 L23.75,14.25 Z M30.875,14.25 L26.125,14.25 L26.125,19 L30.875,19 L30.875,14.25 Z M38,14.25 L33.25,14.25 L33.25,19 L38,19 L38,14.25 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillInTheBlank);
export default __webpack_public_path__ + "static/media/Fill In The Blank.9469bedd.svg";
export { ForwardRef as ReactComponent };